


































import { mapState } from 'vuex';
import { MetaInfo } from 'vue-meta';

import mixin from '@/pages/blog/mixins/mixin';
import ListItem from '@/components/parts/blog/list/components/Item.vue';
import PageBlogLayout from '@/components/page/blog/list';
import { Breadcrumbs } from '@/components/layout';
import SelectCount from '@/components/parts/catalog/list/count';
import { Paginator } from '@/components/parts/pagination';
import { Wrapper } from '@/components/markup';
import BlogChips from '@/pages/blog/list/components/BlogChips.vue';

import PageListMixin from '@/pages/mixin-list';
import createStoreModule, { FETCH_ITEMS, STORE_MODULE_NAME } from './store';
import BlogDateRanges from '@/pages/blog/list/components/BlogDateRanges.vue';
import AppComboBox from '@/uikit/components/AppComboBox/AppComboBox.vue';

const LIMITS = ['9', '18', '27'];
const PAGE_SIZE = LIMITS[0];
const PAGE_NUMBER = 1;

export default {
  name: 'PageBlogList',

  storeName: STORE_MODULE_NAME,
  storeRegister: createStoreModule,

  mixins: [mixin, PageListMixin],
  inject: ['$api'],

  components: {
    AppComboBox,
    BlogDateRanges,
    BlogChips,
    Breadcrumbs,
    PageBlogLayout,
    PageListMixin,
    ListItem,
    Paginator,
    SelectCount,
    Wrapper,
  },

  data() {
    return {
      LIMITS,
      isReady: false,
      multiCop: null,
    };
  },

  computed: {
    ...mapState(STORE_MODULE_NAME, [
      'items',
      'page',
      'pageCount',
      'count',
      'limit',
      'title',
      'metaKeywords',
      'metaDescription',
    ]),

    chips() {
      return this.$store.state.blogEventsDict.map((el) => ({
        text: el.name,
        id: el.id,
      }));
    },

    getMultiCop() {
      return [
        { id: null, text: 'Не выбрано' },
        ...this.$store.state.copMultiDict.map((el) => ({
          id: el.id,
          text: el.name,
        })),
      ];
    },

    key(): string {
      return ['blog', this.$route.fullPath].join('-');
    },
  },
  methods: {
    updateData(newData: string) {
      this.$router.push({
        query: { ...this.$route.query, cop_multi: newData },
      });
    },
  },

  metaInfo(): MetaInfo {
    return {
      title: 'Блог',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Блог ЦОПП',
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'блог, цопп, профессиональная, подготовка, центр',
        },
      ],
    };
  },

  asyncData({ store, route }) {
    // TODO: в навиках для проблем с фильтрами при регистрации нужно попробовать сразу же в asyncData таким образом регистрировать для всех value: [] (массив) -> преобразовать в beforeEach в правильный тип данных query
    const query = { ...route.query };
    const params = {
      ...route.query,
      page: Number(query?.page || PAGE_NUMBER),
      limit: Number(query?.limit || PAGE_SIZE),
      event_type: query?.event_type, // TODO: попробовать удалить
    };
    return store.dispatch(`${STORE_MODULE_NAME}/${FETCH_ITEMS}`, params);
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/blog/list/component.vue